{
  "articlesSection": "Artikel",
  "bookmarkTitleLabel": "Lesezeichen",
  "communitiesSection": "Community-Diskussionen",
  "devConnectionLabel": "Developer Connection",
  "feedback": "Feedback",
  "fetchFailed": "Abruf fehlgeschlagen",
  "help": "Hilfe",
  "helpLoadError": "Ein Fehler ist aufgetreten. Versuchen Sie es erneut.",
  "noBookmarks": "Kennzeichnen Sie die Hilfeinhalte mit einem Lesezeichen, um über diese Seite darauf zuzugreifen.",
  "noBookmarksTitle": "Keine Lesezeichen",
  "noResults": "Keine Ergebnisse gefunden",
  "noResultsMessage": "Überprüfen Sie die Schreibweise oder versuchen Sie es mit einem anderen Suchbegriff.",
  "resourcesCustomerCareLabel": "Kundenunterstützung",
  "resourcesStatusLabel": "Status",
  "solutionsFilterLabel": "Alle Lösungen",
  "support": "Support",
  "videosSection": "Videos"
}
